import { render, staticRenderFns } from "./NsLoyaltyInformation.vue?vue&type=template&id=af669672&scoped=true&"
import script from "./NsLoyaltyInformation.vue?vue&type=script&lang=js&"
export * from "./NsLoyaltyInformation.vue?vue&type=script&lang=js&"
import style0 from "./NsLoyaltyInformation.vue?vue&type=style&index=0&id=af669672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af669672",
  null
  
)

export default component.exports